import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'removeTrailingKwh' })
export class RemoveTrailingKwh implements PipeTransform {
  transform(inputString) {
    var result = inputString.replace(' Kwh', '');
    return result;
  }
}
